import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AuthService } from '../../core/services/auth.service';
import { BusinessInfoDto } from '../../core/models/auth.models';

@Component({
  selector: 'app-select-business',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe, ButtonModule, RadioButtonModule],
  templateUrl: './select-business.component.html',
})
export class SelectBusinessComponent implements OnInit {
  private auth = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);

  businesses: BusinessInfoDto[] = [];
  selectedTenantId: string | null = null;
  loading = false;
  errorMessage: string | null = null;

  ngOnInit(): void {
    const raw = localStorage.getItem('bepos_pending_businesses');
    // eslint-disable-next-line no-useless-assignment
    let list: BusinessInfoDto[] = [];
    try {
      list = raw ? (JSON.parse(raw) as BusinessInfoDto[]) : [];
    } catch {
      list = [];
    }
    if (!Array.isArray(list) || list.length < 2) {
      void this.router.navigate(['/app']);
      return;
    }
    this.businesses = list;
    this.selectedTenantId = list[0]?.tenantId ?? null;
  }

  submit(): void {
    const tenantId = this.selectedTenantId;
    const userId = this.auth.user()?.id;
    if (!tenantId || !userId) return;

    this.errorMessage = null;
    this.loading = true;
    this.auth
      .selectBusiness(userId, tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.loading = false;
          if (!res.success) {
            this.errorMessage = res.errors?.join(' ') ?? 'Error';
            return;
          }
          const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/app';
          void this.router.navigateByUrl(returnUrl);
        },
        error: (err) => {
          this.loading = false;
          const msg =
            err.error?.errors?.join?.(' ') ?? err.error?.message ?? err.message ?? 'Error';
          this.errorMessage = msg;
        },
      });
  }
}
